import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Card, CardActionArea, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { getBoldStyle, getLabelStyle } from "./HeaderWithTitle.constants";
const HeaderWithTitle = ({ id, title, content, titleStyle = {}, contentStyle = {}, disablePadding = false, headerTop = true, onHandleClick, }) => {
    const theme = useTheme();
    const boldStyle = getBoldStyle(theme);
    const labelStyle = getLabelStyle(theme);
    const childrenItems = (_jsxs(_Fragment, { children: [title && (_jsx(Typography, { variant: "h6", sx: Object.assign(Object.assign(Object.assign({}, boldStyle), { mr: 1.5 }), titleStyle), children: headerTop ? title : `${title}:` })), _jsx(Box, { sx: Object.assign(Object.assign(Object.assign({}, labelStyle), (headerTop ? { mr: 1.5, px: 0 } : { px: "15px" })), contentStyle), children: content })] }));
    const clickableCard = (_jsx(Card, { sx: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            my: { xs: disablePadding ? 0 : 0.5 },
            height: 40,
        }, children: _jsx(CardActionArea, { onClick: onHandleClick ? () => onHandleClick(id) : undefined, children: childrenItems }) }));
    const notClickableCard = (_jsx(Box, { sx: Object.assign(Object.assign({}, (headerTop ? undefined : {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
        })), { my: { xs: disablePadding ? 0 : 0.5 } }), children: childrenItems }));
    return _jsxs(Box, { children: [" ", onHandleClick ? clickableCard : notClickableCard, " "] });
};
export default HeaderWithTitle;
